import { Injectable } from 'angular-ts-decorators';

import type { IConfig } from '@shared/app/scripts/services/config';
import type { IStandardErrorParser } from '@shared/app/scripts/services/standard-error-parser';
import { Domain } from '@shared/app/scripts/services/domain';
import { LocationModel } from '@classes/location-model';
import { Sentry } from '@shared/app/scripts/services/sentry';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';

/**
 * Factory in the sharedModule. It takes care of communication with location
 * resource. Methods are inherited form {@link shared.spynlBase
 * spynlBase} service, and are documented there.
 *
 * # Data schema
 * {@link http://docs.dev.swcloud.nl/schemas/bower_components/docson/#../../spynl/location.json
 * is documented with json-schema}
 */
@Injectable('location')
export class Location extends SpynlBase<LocationModel> {
  protected location: string;

  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry: Sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';

    super(
      $http,
      $q,
      sentry,
      domain,
      config,
      standardErrorParser,
      LocationModel,
    );

    this.location = '/locations';
  }

  /**
   *
   * Try fetch active location by a warehouseId field value.
   *
   * @param {string} warehouseId
   * warehouseId
   * @returns {promise} it will resolve with true, or fail with error description
   */
  getById(warehouseId: string): ng.IPromise<LocationModel> {
    return this.filter({ warehouseId, active: true }).then((locations) => {
      const dataArray = locations;
      switch (dataArray.length) {
        case 1:
          return dataArray[0];
        case 0:
          return this.$q.reject('Not found');
        default:
          this.sentry.captureMessage(
            'Found more then one location entity with id = ' + warehouseId,
          );
          return this.$q.reject(
            'Error: found more then 1 location with the same id',
          );
      }
    });
  }
}
